// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// dialogs
import { DialogActions, DialogActionsProps } from '../DialogActions/DialogActions';

// forms
import { FormAddIncident } from '../../forms/FormAddIncident/FormAddIncident';

// props
export interface DialogAddIncidentProps {
	isOpen: boolean;
	onClose: () => void;
	onSuccess?: () => void;
}

export const DialogAddIncident = ({ isOpen, onClose, onSuccess }: DialogAddIncidentProps) => {
	// hooks
	const { t } = useTranslation();

	// state
	const [isLoading, setIsLoading] = useState(false);

	// vars
	let IconCircleProps: DialogActionsProps['IconCircleProps'];
	let subtitle: DialogActionsProps['subtitle'];

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: t('submitFeedback'),
					form: 'form-add-incident',
					type: 'submit',
					loading: isLoading,
					variant: 'contained',
				},
			]}
			hasClose={true}
			IconCircleProps={IconCircleProps}
			isOpen={isOpen}
			onClose={onClose}
			subtitle={subtitle}
			title={{
				children: t('submitFeedback'),
				variant: 'h3',
			}}>
			<FormAddIncident onClose={onClose} onSuccess={onSuccess} setIsLoading={setIsLoading} />
		</DialogActions>
	);
};
